<template>
    <a-modal
        :title="dataInfo.id ? $t('web.edit' /* 编辑 */) : $t('web.new' /* 新增 */)"
        :visible="visible"
        :confirm-loading="confirmLoading"
        :bodyStyle="{ height: '500px', 'overflow-y': 'auto' }"
        :width="800"
        :maskClosable="false"
        @ok="handleOk"
        @cancel="handleCancel"
    >
        <a-form :form="form" layout="vertical">
            <div class="title fs18 strong">{{ $t('goods.basic_info') }}</div>
            <!-- 基本信息 -->
            <a-row :gutter="[10, 0]">
                <a-col :xs="24" :sm="12">
                    <a-form-item :label="$t('goods.rule_name')">
                        <!-- 规则名称 -->
                        <a-input
                            style="width: 100%"
                            v-decorator="['name', { rules: [{ required: true, message: $t('formConfig.please_enter') + $t('goods.rule_name') }] }]"
                            :placeholder="$t('formConfig.please_enter') + $t('goods.rule_name')"
                        />
                        <!-- 请输入规则名称 -->
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="12">
                    <a-form-item :label="$t('goods.implementation_period')">
                        <!-- 实行时段 -->
                        <a-range-picker
                            style="width: 100%"
                            v-decorator="['time', { rules: [{ required: true, message: $t('formConfig.please_select') + $t('goods.implementation_period') }] }]"
                            show-time
                        />
                        <!-- 请选择实行时段 -->
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item :label="$t('goods.description_info')">
                        <!-- 说明信息 -->
                        <a-textarea
                            style="width: 100%"
                            v-decorator="['introduction', { rules: [{ required: true, message: $t('formConfig.please_enter') + $t('goods.description_info') }] }]"
                            :placeholder="$t('formConfig.please_enter') + $t('goods.description_info')"
                        />
                        <!-- 请输入说明信息 -->
                    </a-form-item>
                </a-col>
            </a-row>

            <div class="title fs18 strong">{{ $t('goods.condition_info') }}</div>
            <!-- 条件信息 -->

            <div class="rule-items" v-for="(ruleItem, ruleIndex) in form.getFieldValue('ruleGather')" :key="ruleIndex">
                <div class="rule-item mt30">
                    <div class="remove-rule" v-if="ruleIndex">
                        <a-button type="link" icon="delete" class="rule-remove-btn" @click="handleRemoveRule(ruleIndex)" />
                    </div>
                    <div class="condition-item" v-for="(k, index) in ruleItem" :key="k">
                        <div class="flex y-center x-left condition-box">
                            <div class="t">{{ $t('goods.condition') }}{{ index + 1 }}</div>
                            <!-- 条件 -->
                            <div class="form-box flex-item ml20">
                                <a-row :gutter="[10, 0]">
                                    <a-col :span="12">
                                        <a-form-item>
                                            <a-select
                                                mode="multiple"
                                                style="width: 100%"
                                                v-decorator="[`condition[${ruleIndex}][${k}][group]`, { rules: [{ required: true, message: $t('goods.please_select_object') }] }]"
                                                :placeholder="$t('goods.please_select_object')"
                                            >
                                                <!-- 请选择对象 -->
                                                <a-select-option v-for="(item, index) in group" :value="item.value" :key="index">{{ item.label }}</a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item>
                                            <a-select
                                                style="width: 100%"
                                                v-decorator="[`condition[${ruleIndex}][${k}][symbol]`, { rules: [{ required: true, message: $t('goods.please_select_logic_rule') }] }]"
                                                :placeholder="$t('goods.please_select_logic_rule')"
                                            >
                                                <!-- 请选择逻辑规则 -->
                                                <a-select-option v-for="(item, index) in symbol" :value="item.value" :key="index">{{ item.label }}</a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item style="margin-bottom: 0; padding-bottom: 0">
                                            <a-select
                                                mode="multiple"
                                                style="width: 100%"
                                                v-decorator="[`condition[${ruleIndex}][${k}][goods_ids]`, { rules: [{ required: true, message: $t('goods.please_select_specific_parameters') }] }]"
                                                :placeholder="$t('goods.please_select_specific_parameters')"
                                            >
                                                <!-- 请选择具体参数 -->
                                                <a-select-option v-for="(item, index) in goodsList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </div>
                            <div class="action ml10" v-if="ruleItem.length > 1" @click="handleRemoveCondition(ruleIndex, k)">
                                <a-button type="link" icon="minus-circle" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="title fs18 strong mt20">{{ $t('goods.event_info') }}</div>
            <!-- 事件信息 -->
            <div class="event-items mt15">
                <div class="event-item" v-for="(eventItem, eventIndex) in form.getFieldValue('eventGather')" :key="eventIndex">
                    <div class="flex y-center x-left">
                        <div>{{ $t('goods.event') }}{{ eventIndex + 1 }}</div>
                        <!-- 事件 -->
                        <div class="form-box flex-item ml20">
                            <a-row :gutter="[10, 0]">
                                <a-form-item style="display: none">
                                    <a-input type="hidden" v-decorator="[`event[${eventItem}][id]`]"></a-input>
                                </a-form-item>
                                <a-col :span="24">
                                    <a-form-item>
                                        <a-select
                                            style="width: 100%"
                                            v-decorator="[`event[${eventItem}][event_type]`, { rules: [{ required: true, message: $t('formConfig.please_select') + $t('goods.event') }] }]"
                                            :placeholder="$t('formConfig.please_select') + $t('goods.event')"
                                        >
                                            <!-- 请选择事件 -->
                                            <a-select-option value="1">{{ $t('goods.prompt_text_information') }}</a-select-option>
                                            <!-- 提示文字信息 -->
                                            <a-select-option value="2">{{ $t('goods.restrict_order_and_prompt_text_information') }}</a-select-option>
                                            <!-- 限制下单并提示文字信息 -->
                                            <a-select-option value="3">{{ $t('goods.collect_audit_attachment_materials') }}</a-select-option>
                                            <!-- 收集审核附件材料 -->
                                            <a-select-option value="4">{{ $t('goods.additional_content_collection_items') }}</a-select-option>
                                            <!-- 附加内容收集项 -->
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <template v-if="form.getFieldValue(`event[${eventItem}][event_type]`) == 3">
                                    <a-col :span="12">
                                        <a-form-item>
                                            <a-input
                                                style="width: 100%"
                                                v-decorator="[`event[${eventItem}][cert_name]`, { rules: [{ required: true, message: $t('formConfig.please_enter_audit_certificate_name') }] }]"
                                                :placeholder="$t('formConfig.please_enter_audit_certificate_name')"
                                            />
                                            <!-- 请输入被审核证件名称 -->
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item>
                                            <a-select
                                                style="width: 100%"
                                                v-decorator="[`event[${eventItem}][cert_type]`, { rules: [{ required: true, message: $t('goods.please_select_field_type') }] }]"
                                                :placeholder="$t('goods.please_select_field_type')"
                                            >
                                                <!-- 请选择字段类型 -->
                                                <a-select-option value="1">{{ $t('goods.single_line_text') }}</a-select-option>
                                                <!-- 单行文本 -->
                                                <a-select-option value="2">{{ $t('goods.upload_file') }}</a-select-option>
                                                <!-- 上传文件 -->
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24" v-if="form.getFieldValue(`event[${eventItem}][cert_type]`) == 2">
                                        <a-row :gutter="[10, 0]">
                                            <a-col :span="12">
                                                <a-form-item>
                                                    <a-select
                                                        style="width: 100%"
                                                        :placeholder="$t('goods.please_select_maximum_number_of_files_to_upload')"
                                                        v-decorator="[
                                                            `event[${eventItem}][cert_max_num]`,
                                                            { rules: [{ required: true, message: $t('formConfig.please_enter_maximum_number_of_files_to_upload') }] }
                                                        ]"
                                                    >
                                                        <!-- 请选择最多上传文件数量 -->
                                                        <a-select-option :value="String(item)" v-for="(item, index) in 10" :key="item">
                                                            {{ $t('goods.most_upload') }} {{ item }} {{ $t('goods.files') }}
                                                        </a-select-option>
                                                        <!-- 最多上传 {{ item }} 个 -->
                                                    </a-select>
                                                </a-form-item>
                                            </a-col>
                                            <a-col :span="12">
                                                <a-form-item>
                                                    <a-select
                                                        mode="multiple"
                                                        style="width: 100%"
                                                        :placeholder="$t('goods.please_select_file_types_to_upload')"
                                                        v-decorator="[`event[${eventItem}][cert_suffix]`, { rules: [{ required: true, message: $t('goods.please_select_file_types_to_upload') }] }]"
                                                    >
                                                        <!-- 请选择上传文件类型 -->
                                                        <a-select-option v-for="(item, sIndex) in suffixList" :key="sIndex" :value="item.id">{{ item.value }}</a-select-option>
                                                    </a-select>
                                                </a-form-item>
                                            </a-col>
                                        </a-row>
                                    </a-col>
                                </template>
                                <template v-else-if="form.getFieldValue(`event[${eventItem}][event_type]`) == 4">
                                    <a-col :span="24">
                                        <a-form-item :extra="$t('goods.please_select_form_collection_items')">
                                            <!-- 请选择表单收集项，管理收集项请前往“用户”-“注册表单配置” -->
                                            <a-select
                                                mode="multiple"
                                                style="width: 100%"
                                                v-decorator="[`event[${eventItem}][form_ids]`, { rules: [{ required: true, message: $t('goods.please_select_field_type') }] }]"
                                                :placeholder="$t('goods.please_select_field_type')"
                                            >
                                                <!-- 请选择字段类型 -->
                                                <a-select-option v-for="(item, index) in formData" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                                            </a-select>
                                        </a-form-item>
                                    </a-col>
                                </template>
                                <template v-else>
                                    <a-col :span="24">
                                        <a-form-item>
                                            <a-textarea
                                                style="width: 100%"
                                                v-decorator="[`event[${eventItem}][verify_note]`, { rules: [{ required: true, message: $t('formConfig.please_enter_prompt_content') }] }]"
                                                :placeholder="$t('formConfig.please_enter_prompt_content')"
                                            />
                                            <!-- 请输入提示内容 -->
                                        </a-form-item>
                                    </a-col>
                                </template>
                            </a-row>
                        </div>
                        <div class="action ml10" @click="handleRemoveEvent(eventItem, eventIndex)" v-if="eventIndex">
                            <a-button type="link" icon="minus-circle" />
                        </div>
                    </div>
                </div>
                <a-button type="dashed mt10 add-event-box" @click="handleAddEvent">
                    <a-icon type="plus-circle" />
                    {{ $t('goods.add_event') }}
                    <!-- 添加事件 -->
                </a-button>
            </div>
        </a-form>
    </a-modal>
</template>

<script>
import pick from 'lodash.pick';
import moment from 'moment/moment';
const fields = ['id', 'name', 'introduction', 'time'];
// 表单类型
const form_type = [
    {
        icon: 'med-wenben',
        name: '普通文本框',
        type: 'text'
    },
    {
        icon: 'med-iocnwenben',
        name: '多行文本框',
        type: 'textarea'
    },
    {
        icon: 'med-danxuanti',
        name: '单选框',
        type: 'radio'
    },
    {
        icon: 'med-muti-selector',
        name: '多选框',
        type: 'checkbox'
    },
    {
        icon: 'med-select',
        name: '下拉选择框',
        type: 'select'
    },
    {
        icon: 'med-rili',
        name: '日历',
        type: 'date'
    },
    {
        icon: 'med-shangchuan',
        name: '上传文件',
        type: 'file'
    }
];
export default {
    name: 'MarketEdit',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        dataInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            confirmLoading: false,
            form: this.$form.createForm(this, { name: 'marketEdit' }),
            group: [], // 对象
            symbol: [], // 逻辑规则
            goodsList: [], // 门票列表
            language: 'cn', //语言
            formData: [], //表单收集项下拉
            suffixList: [] //文件后缀下拉
        };
    },
    created() {
        this.getEnumList();
        this.getGoodsList();
        fields.forEach(v => this.form.getFieldDecorator(v)); // 初始化表单字段
        this.form.getFieldDecorator('ruleGather', { initialValue: [[0]], preserve: true }); // 条件信息初始化
        this.form.getFieldDecorator('eventGather', { initialValue: [0], preserve: true }); // 事件信息初始化
    },
    watch: {
        dataInfo: {
            handler(val) {
                if (val.id) {
                    this.form.getFieldDecorator('id', { initialValue: val.id, preserve: true }); // 增加id字段
                    // ruleGather 根据condition的长度来初始化 [[{},{}],[{}]] => [[0,1],[0]]
                    // eventGather 根据event的长度来初始化 [{},{}] => [0,1]
                    const { condition, event } = val;
                    const ruleGather = condition.map(item => item.map((item, index) => index));
                    const eventGather = event.map((item, index) => index);
                    this.form.setFieldsValue({
                        ruleGather,
                        eventGather
                    }); // 初始化条件信息
                    val.start_time && (val.time = [moment(val.start_time), moment(val.end_time)]);
                    this.form.setFieldsValue(pick(val, fields));

                    // 给 condition 和 event 添加默认值
                    condition.forEach((item, index) => {
                        item.forEach((data, idx) => {
                            this.form.getFieldDecorator(`condition[${index}][${idx}][group]`, { initialValue: data.group, preserve: true });
                            this.form.getFieldDecorator(`condition[${index}][${idx}][symbol]`, { initialValue: data.symbol, preserve: true });
                            this.form.getFieldDecorator(`condition[${index}][${idx}][goods_ids]`, { initialValue: data.goods_ids, preserve: true });
                        });
                    });
                    event.forEach((item, index) => {
                        this.form.getFieldDecorator(`event[${index}][event_type]`, { initialValue: item.event_type, preserve: true });
                        if (item.event_type == 3) {
                            item.cert_suffix = item.cert_suffix.split(',');
                            this.form.getFieldDecorator(`event[${index}][cert_name]`, { initialValue: item.cert_name, preserve: true });
                            this.form.getFieldDecorator(`event[${index}][cert_type]`, { initialValue: item.cert_type, preserve: true });
                            this.form.getFieldDecorator(`event[${index}][cert_max_num]`, { initialValue: item.cert_max_num, preserve: true });
                            this.form.getFieldDecorator(`event[${index}][cert_suffix]`, { initialValue: item.cert_suffix, preserve: true });
                        } else if (item.event_type == 4) {
                            item.form_ids = Array.isArray(item.form_ids) ? item.form_ids : item.form_ids.split(',').filter(item => item);
                            this.form.getFieldDecorator(`event[${index}][form_ids]`, { initialValue: item.form_ids, preserve: true });
                        } else {
                            this.form.getFieldDecorator(`event[${index}][verify_note]`, { initialValue: item.verify_note, preserve: true });
                        }
                        this.form.getFieldDecorator(`event[${index}][id]`, { initialValue: item.id, preserve: true });
                    });
                }
            },
            deep: true
        },
        $route: {
            handler(newVal) {
                this.language = window.location.hash.match(/(cn|en)/)[0];
                this.getFormData();
            },
            immediate: true
        }
    },
    methods: {
        getEnumList() {
            this.$request.get({ url: 'getSaleLimitEnum' }).then(res => {
                let { group, symbol, upload_suffix } = res.data;
                // 1 : "普通参会代表" => { value : 1 , label : "普通参会代表"}
                group = Object.keys(group).map(key => ({ value: key, label: group[key] }));
                symbol = Object.keys(symbol).map(key => ({ value: key, label: symbol[key] }));
                this.group = group;
                this.symbol = symbol;
                // 后缀下拉
                let resultData = [];
                let suffixArr = upload_suffix[0].split(',');
                suffixArr = [...new Set(suffixArr)]; //去重
                suffixArr.forEach(item => {
                    resultData.push({
                        id: item,
                        value: item
                    });
                });
                this.suffixList = resultData;
            });
        },
        // 获取门票列表
        getGoodsList() {
            let data = {
                page: 1,
                limit: 1000 // 默认全部
            };
            this.$request.get({ url: 'getGoodsList', data }).then(res => {
                this.goodsList = res.data.data;
            });
        },
        handleOk() {
            this.form.validateFields((err, values) => {
                console.log(values);
                console.log(err);
                if (!err) {
                    delete values.ruleGather;
                    delete values.eventGather;
                    values.start_time = values.time[0].format('YYYY-MM-DD HH:mm:ss');
                    values.end_time = values.time[1].format('YYYY-MM-DD HH:mm:ss');
                    delete values.time;
                    // 过滤掉 condition 中条件中的空值
                    values.condition = values.condition.map(item => item.filter(data => data.group && data.symbol && data.goods_ids)).filter(item => item.length > 0); // 先过滤空数据然后过滤掉空数组;
                    values.condition = JSON.stringify(values.condition);
                    // 过滤掉 event 中条件中的空值
                    values.event = values.event.filter(item => item.event_type || item.verify_note || item.cert_name || item.cert_type);
                    values.event.forEach(item => {
                        item.cert_suffix && (item.cert_suffix = item.cert_suffix.join(','));
                        item.form_ids && (item.form_ids = item.form_ids.join(','));
                    }); // 数组转字符串
                    values.event = JSON.stringify(values.event);
                    this.$request
                        .post({ url: 'limitCreateUpdate', data: values })
                        .then(res => {
                            this.$message.success('操作成功');
                            this.close();
                            this.$emit('ok');
                        })
                        .catch(err => {
                            this.$message.error(err.msg);
                        });
                }
            });
        },
        handleCancel() {
            this.close();
            this.$emit('cancel');
        },
        close() {
            this.form.resetFields();
            // 清楚掉 condition 和 event 的默认值
            this.form.getFieldDecorator('id', { initialValue: '', preserve: true }); // 增加id字段
            let { condition, event } = this.form.getFieldsValue();
            // resetFields 清除不掉默认值，所以需要手动清除
            condition.forEach((item, index) => {
                item.forEach((data, idx) => {
                    this.form.getFieldDecorator(`condition[${index}][${idx}][group]`, { initialValue: undefined, preserve: true });
                    this.form.getFieldDecorator(`condition[${index}][${idx}][symbol]`, { initialValue: undefined, preserve: true });
                    this.form.getFieldDecorator(`condition[${index}][${idx}][goods_ids]`, { initialValue: undefined, preserve: true });
                });
            });
            event.forEach((item, index) => {
                this.form.getFieldDecorator(`event[${index}][event_type]`, { initialValue: undefined, preserve: true });
                this.form.getFieldDecorator(`event[${index}][verify_note]`, { initialValue: undefined, preserve: false });
                this.form.getFieldDecorator(`event[${index}][cert_name]`, { initialValue: undefined, preserve: false });
                this.form.getFieldDecorator(`event[${index}][cert_type]`, { initialValue: undefined, preserve: false });
                this.form.getFieldDecorator(`event[${index}][cert_max_num]`, { initialValue: undefined, preserve: false });
                this.form.getFieldDecorator(`event[${index}][cert_suffix]`, { initialValue: undefined, preserve: false });
                this.form.getFieldDecorator(`event[${index}][form_ids]`, { initialValue: undefined, preserve: false });
                this.form.getFieldDecorator(`event[${index}][id]`, { initialValue: undefined, preserve: true });
            });
            this.form.getFieldDecorator('ruleGather', { initialValue: [[0]], preserve: true }); // 条件信息初始化
            this.form.getFieldDecorator('eventGather', { initialValue: [0], preserve: true }); // 事件信息初始化
        },
        // 添加规则
        handleAddRule() {
            const { form } = this;
            const ruleGather = form.getFieldValue('ruleGather');
            const nextRuleGather = ruleGather.concat([[0]]); //添加一个规则
            console.log(nextRuleGather, 'nextRuleGather');
            form.setFieldsValue({
                ruleGather: nextRuleGather
            });
        },
        // 删除规则
        handleRemoveRule(k) {
            const { form } = this;
            const ruleGather = form.getFieldValue('ruleGather');
            if (ruleGather.length === 1) {
                return;
            }
            ruleGather.splice(k, 1); //删除指定位置的元素
            form.setFieldsValue({
                ruleGather: ruleGather
            });
            const condition = form.getFieldValue('condition');
            condition.forEach((item, index) => {
                if (index != k) return;
                item.forEach((data, idx) => {
                    this.form.getFieldDecorator(`condition[${index}][${idx}][group]`, { initialValue: undefined, preserve: true });
                    this.form.getFieldDecorator(`condition[${index}][${idx}][symbol]`, { initialValue: undefined, preserve: true });
                    this.form.getFieldDecorator(`condition[${index}][${idx}][goods_ids]`, { initialValue: undefined, preserve: true });
                });
            });
        },
        // 添加条件
        handleAddCondition(ruleIndex) {
            const { form } = this;
            const ruleGather = form.getFieldValue('ruleGather');
            const nextRuleGather = ruleGather.map((item, index) => {
                if (index === ruleIndex) {
                    let maxNumber = Math.max(...item);
                    return item.concat([maxNumber + 1]);
                }
                return item;
            });
            form.setFieldsValue({
                ruleGather: nextRuleGather
            });
        },
        // 删除条件
        handleRemoveCondition(ruleIndex, k) {
            const { form } = this;
            const ruleGather = form.getFieldValue('ruleGather');
            const nextRuleGather = ruleGather.map((item, index) => {
                if (index === ruleIndex) {
                    return item.filter((item, index) => item !== k);
                }
                return item;
            });
            // 清除掉默认值
            this.form.getFieldDecorator(`condition[${ruleIndex}][${k}][group]`, { initialValue: undefined, preserve: true });
            this.form.getFieldDecorator(`condition[${ruleIndex}][${k}][symbol]`, { initialValue: undefined, preserve: true });
            this.form.getFieldDecorator(`condition[${ruleIndex}][${k}][goods_ids]`, { initialValue: undefined, preserve: true });
            console.log(k, nextRuleGather, form.getFieldValue('condition'));
            form.setFieldsValue({
                ruleGather: nextRuleGather
            });
        },
        // 添加事件
        handleAddEvent() {
            const { form } = this;
            const eventGather = form.getFieldValue('eventGather');
            const nextEventGather = eventGather.concat(eventGather.length);
            console.log(eventGather);
            form.setFieldsValue({
                eventGather: nextEventGather
            });
        },
        // 删除事件
        handleRemoveEvent(k, index) {
            const { form } = this;
            const eventGather = form.getFieldValue('eventGather');
            if (eventGather.length === 1) {
                return;
            }
            eventGather.splice(index, 1); //删除指定位置的元素
            // 清除掉默认值
            this.form.getFieldDecorator(`event[${k}][event_type]`, { initialValue: undefined, preserve: true });
            this.form.getFieldDecorator(`event[${k}][verify_note]`, { initialValue: undefined, preserve: true });
            this.form.getFieldDecorator(`event[${k}][cert_name]`, { initialValue: undefined, preserve: true });
            this.form.getFieldDecorator(`event[${k}][cert_type]`, { initialValue: undefined, preserve: true });
            this.form.getFieldDecorator(`event[${k}][cert_max_num]`, { initialValue: undefined, preserve: true });
            this.form.getFieldDecorator(`event[${k}][cert_suffix]`, { initialValue: undefined, preserve: true });
            this.form.getFieldDecorator(`event[${k}][form_ids]`, { initialValue: undefined, preserve: true });
            this.form.getFieldDecorator(`event[${k}][id]`, { initialValue: undefined, preserve: true });
            console.log(k, eventGather, form.getFieldValue('event'));
            form.setFieldsValue({
                eventGather: eventGather
            });
        },
        // 获取表单数据
        getFormData() {
            let data = {
                language: 'cn',
                form_type: 'user', // user：个人注册 team：团队注册 channel:通道 exhibitors：展商
                hide_status: 1 //隐藏表单
            };
            this.$request
                .get({ url: 'getFormData', data })
                .then(res => {
                    this.formDataList = res.data;
                    let resultData = [];
                    res.data.forEach(item => {
                        // 技术职称【单选-必填】
                        let typeItem = form_type.filter(typeItem => typeItem.type == item.field_type);
                        let type = typeItem.length ? typeItem[0].name : '未知';
                        let name = `${item.field_name}【${type}-${item.is_null == 1 ? '必填' : '非必填'}】`;
                        resultData.push({
                            id: item.id,
                            name
                        });
                    });
                    this.formData = resultData;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style scoped lang="less">
/deep/ .ant-form-vertical .ant-form-item {
    margin-bottom: 10px;
}
body {
    counter-reset: section;
}
.rule-items {
    counter-increment: section; //计数器+1
    .rule-item {
        padding: 20px;
        border: 1px solid #e8e8e8;
        position: relative;
        &::before {
            content: '规则' counter(section);
            padding: 3px 6px;
            background: #ffffff;
            position: absolute;
            top: -16px;
            left: 12px;
            font-size: 14px;
            font-weight: bold;
        }
    }
}
.event-items {
    padding: 20px;
    border: 1px solid #e8e8e8;
    position: relative;
    .event-item {
        background: #f6f6f6;
        padding: 10px;
        overflow-x: auto;
        /deep/ .ant-form-item {
            margin-bottom: 0;
        }
    }
}

.rule-remove-btn {
    color: #ff4d4f;
    font-size: 14px;
    padding: 0;
    margin: 0;
    position: absolute;
    right: 6px;
    top: -16px;
    background: #ffffff;
}
.condition-box {
    padding: 10px;
    background: #f6f6f6;
    overflow-x: auto;
}
.add-condition-box {
    width: 100%;
    height: 50px;
}
.add-event-box {
    width: 100%;
}
</style>
